import { render, staticRenderFns } from "./SceneLabelUsage.vue?vue&type=template&id=11cd84ff&"
import script from "./SceneLabelUsage.vue?vue&type=script&lang=ts&"
export * from "./SceneLabelUsage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports